import { useMutation } from '@tanstack/react-query';
import api from '../lib/api';
import { useAuthStore } from '../stores/auth-store';

interface SwitchOrgResult {
  accessToken: string;
  organization: { id: string; name: string; slug: string };
}

export function useSwitchOrg() {
  const switchOrg = useAuthStore((s) => s.switchOrg);

  return useMutation({
    mutationFn: async (organizationId: string) => {
      const res = await api.post<{ data: SwitchOrgResult }>('/auth/switch-org', { organizationId });
      return res.data.data;
    },
    onSuccess: (data) => {
      switchOrg(data.organization.id, data.organization.name, data.accessToken);
      window.location.reload();
    },
  });
}
